import ErrorIcon from "@mui/icons-material/Error";
import React from "react";

function UnderReview() {
  return (
    <div className="h-[calc(100vh-165px)] sm:h-full flex flex-col items-center justify-center px-4">
      <div className="max-w-[400px] flex flex-col items-center justify-center">
        <ErrorIcon sx={{ color: "#FFCC31", fontSize: "90px" }} />
        <p className="text-[#1F2328] text-xl font-bold my-2 text-center">
          Under Review
        </p>
        <p className="text-[#60656D] text-center">
          Your KYC documents are under review. We'll update you as soon as the
          verification process is complete.
        </p>
        <p className="text-[#60656D] text-center">
          Thank you for your patience!
        </p>
      </div>
    </div>
  );
}

export default UnderReview;
